



















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class LingkarKepala extends Vue {
  @Prop() setLingkarKepala: string;
  @Prop() setLabel!: string;
  label = "";
  placeholder = this.setLabel;
  msg = "";
  validasi = [(v) => this.cek(v) || this.message()];
  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setLingkarKepala == "" || this.setLingkarKepala == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }
  @Watch("setLingkarKepala")
  changeLingkarKepala(v) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (v == "" || v == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("lingkarkepala", v);
    // console.log(v);
    this.setLingkarKepala = v;
  }

  titik() {
    if (this.setLingkarKepala) {
      this.setLingkarKepala = this.setLingkarKepala.split(",").join(".");
    }
  }

  cek(v) {
    if (this.setLingkarKepala != null) {
      if (
        this.setLingkarKepala.substring(
          this.setLingkarKepala.length - 1,
          this.setLingkarKepala.length
        ) == ","
      ) {
        this.titik();
      } else if (isNaN(Number(this.setLingkarKepala)))
        this.setLingkarKepala = this.setLingkarKepala.substring(
          0,
          this.setLingkarKepala.length - 1
        );
      if (this.setLingkarKepala.length > 5)
        this.setLingkarKepala = this.setLingkarKepala.substring(
          0,
          this.setLingkarKepala.length - 1
        );
    }
    if (Number(v) > 200) {
      this.msg = "*Lingkar Kepala " + v + " cm, Anda yakin?";
      return false;
    } else return true;
  }

  message() {
    return this.msg;
  }
}
